import React from 'react';
import Icon, { IconProps } from './Icon';

const UserIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor', ...props }) => {
  return (
    <Icon size={size} color={color} viewBox="0 0 24 24" {...props}>
      <path
        d="M19.9998 21.0001C19.9998 19.6046 19.9998 18.9068 19.8275 18.339C19.4397 17.0606 18.4393 16.0602 17.1609 15.6724C16.5931 15.5001 15.8953 15.5001 14.4998 15.5001H9.49976C8.10419 15.5001 7.40641 15.5001 6.83861 15.6724C5.56021 16.0602 4.5598 17.0606 4.172 18.339C3.99976 18.9068 3.99976 19.6046 3.99976 21.0001M16.4998 7.50012C16.4998 9.9854 14.485 12.0001 11.9998 12.0001C9.51447 12.0001 7.49976 9.9854 7.49976 7.50012C7.49976 5.01484 9.51447 3.00012 11.9998 3.00012C14.485 3.00012 16.4998 5.01484 16.4998 7.50012Z"
        stroke={color}
        strokeWidth="2.00002"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </Icon>
  );
};

export default UserIcon;

